<template>
    <div class="app-layout">
        <app-header/>
        <div class="app-body">
            <AppSidebar />

            <main id="app-main" class="main theme-default">
                <app-breadcrumb :list="list"/>
                <rq-banner
                    variant="system"
                    title="READ ONLY"
                    icon="fas fa-exclamation-circle"
                    :visible="readOnly"
                />
                <RouterView></RouterView>
            </main>
        </div>
        <app-icon-symbols />
    </div>
</template>

<script setup>
    import { computed } from "vue";
    import { useStore } from "vuex";
    import { useRoute } from "vue-router";

    import {
        AppHeader,
        AppSidebar,
        AppBreadcrumb,
        AppIconSymbols
    } from "@/components/";

    const store = useStore();
    const route = useRoute();

    const readOnly = computed(() => store.state.isPageReadOnly);
    const list = computed(() => _.filter(route.matched, r => _.get(r, "meta.include", true)));
</script>